import { BaseApiModel } from './BaseApiModel';

export class ViolationReport extends BaseApiModel {
  public contractId: string;
  public date: string;
}
